import React from 'react';
import { NavLink } from 'react-router-dom';
import { LucideIcon, ExternalLink } from 'lucide-react';

interface NavItemProps {
    path: string;
    label: string;
    icon: LucideIcon;
    external?: boolean;
    sidebarOpen: boolean;
    isActive: boolean;
}

export const NavItem: React.FC<NavItemProps> = ({
    path,
    label,
    icon: Icon,
    external,
    sidebarOpen,
    isActive
}) => {
    if (external) {
        return (
            <li>
                <a
                    href={path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group relative flex items-center gap-2 px-3 py-2 rounded-lg transition-all duration-200 cursor-pointer text-sm hover:bg-slate-100 dark:hover:bg-gray-700/40 hover:translate-x-1"
                >
                    <div className="w-6 h-6 rounded-md flex items-center justify-center transition-all bg-slate-200 dark:bg-gray-600 group-hover:bg-blue-100 dark:group-hover:bg-blue-900/40">
                        <Icon size={14} className="text-slate-600 dark:text-gray-300" />
                    </div>
                    {sidebarOpen && (
                        <span className="transition-colors text-slate-600 dark:text-gray-300 group-hover:text-slate-900 dark:group-hover:text-white flex items-center gap-1">
                            {label}
                            <ExternalLink size={10} className="opacity-50" />
                        </span>
                    )}
                </a>
            </li>
        );
    }

    return (
        <li>
            <NavLink
                to={path}
                className={`
                    group relative flex items-center gap-2 px-3 py-2 rounded-lg
                    transition-all duration-200 cursor-pointer text-sm
                    ${isActive ? 'bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/30 dark:to-indigo-900/30 text-blue-700 dark:text-blue-300 shadow-sm font-medium scale-[1.01]' : 'hover:bg-slate-100 dark:hover:bg-gray-700/40 hover:translate-x-1'}
                `}
            >
                <div className={`w-6 h-6 rounded-md flex items-center justify-center transition-all ${isActive ? 'bg-blue-500 shadow-md' : 'bg-slate-200 dark:bg-gray-600 group-hover:bg-blue-100 dark:group-hover:bg-blue-900/40'}`}>
                    <Icon size={14} className={isActive ? 'text-white' : 'text-slate-600 dark:text-gray-300'} />
                </div>
                {sidebarOpen && (
                    <span className={`transition-colors ${isActive ? 'text-blue-700 dark:text-blue-300 font-medium' : 'text-slate-600 dark:text-gray-300 group-hover:text-slate-900 dark:group-hover:text-white'}`}>
                        {label}
                    </span>
                )}
                {isActive && sidebarOpen && <div className="ml-auto w-2 h-2 bg-blue-500 rounded-full animate-pulse" />}
            </NavLink>
        </li>
    );
};
